import React from "react";

import "../css/startScreen.css";

function StartScreen(props) {
    return (
        <div id="startScreen">
            <div>Press space bar to start the game...</div>
        </div>
    );
}

export default StartScreen;